import { GapFillStatusEnum } from "@app/projects/network-assessment/adequacy";

export const presentableGapFillStatusRecord: Record<GapFillStatusEnum, string> = {
  [GapFillStatusEnum.none]: "---",
  [GapFillStatusEnum.gapFilled]: "IP - Gap Filled",
  [GapFillStatusEnum.researching]: "IP - Researching",
  [GapFillStatusEnum.contractingGapClosure]: "IP - Contracting",
  [GapFillStatusEnum.contractingExceptionEligible]: "IP - Exception Eligible",
  [GapFillStatusEnum.exceptionRequired]: "Exception - Required",
  [GapFillStatusEnum.rppoWaiverRequired]: "Exception - RPPO",
  [GapFillStatusEnum.availableEntitiesWillNotContract]: "High Risk"
};
